/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { GetSegmentInfoResponseDto } from 'customer-speed-api';
import { ILatLng, LatLng } from '../../core/models';
import { EPanelDrawerState } from '../../replay/models';
import {
  EManagePostedSpeedTabs,
  IFilters,
  IPostedSpeedUpdate,
  IRoadDetails,
  ISegmentGroup,
  ISelectedSegment,
  IUpdateSpeedLimitForm,
  ROAD_DIRECTION
} from '../models';

export interface ISegmentSelectionSnapshot {
  selectedSegments: Record<string, ISelectedSegment>;
}

export interface IManagePostedSpeedState {
  activeTab: EManagePostedSpeedTabs;
  mapCenter: LatLng | null;
  canUndo: boolean;
  canRedo: boolean;
  past: ISegmentSelectionSnapshot[];
  future: ISegmentSelectionSnapshot[];
  selectedRoads: IRoadDetails[];
  updateFormSelectedRoads: IRoadDetails[];
  postedSpeedUpdates: IPostedSpeedUpdate[];
  totalItems: number;
  totalAccountOverrides: number;
  filters: IFilters;
  allowMapRefine: boolean;
  isUpdateFormOpen: boolean;
  updateSpeedLimitForm: IUpdateSpeedLimitForm;
  drawerState: EPanelDrawerState;
  selectedSegmentId: string | null;
  selectedSegmentRef: string | null;
  decodedGeometry: ILatLng[] | null;
  segmentInfo: GetSegmentInfoResponseDto | null;
  isSegmentSelected: boolean;
  editingOverrideId: string | null;
  originalFormValues: IUpdateSpeedLimitForm | null;
  hoveredUpdateId: string | null;
  selectedUpdateId: string | null;
  lastSavedOverrideId: string | null;
  selectedSegments: Record<string, ISelectedSegment>;
  segmentGroups: ISegmentGroup[];
  segmentError: boolean;
  /** True while a saveOverride request is in progress. Cleared on success or failure. */
  isSaving: boolean;
}

export const initialManagePostedSpeedState: IManagePostedSpeedState = {
  activeTab: EManagePostedSpeedTabs.Update,
  mapCenter: null,
  canUndo: false,
  canRedo: false,
  past: [],
  future: [],
  selectedRoads: [],
  updateFormSelectedRoads: [],
  postedSpeedUpdates: [],
  totalItems: 0,
  totalAccountOverrides: 0,
  filters: {
    startDate: null,
    endDate: null,
    statuses: ['Active', 'Planned']
  },
  allowMapRefine: true,
  isUpdateFormOpen: false,
  updateSpeedLimitForm: {
    updatedPostedSpeedLimit: null,
    directionOfEdit: ROAD_DIRECTION.Both,
    startDate: null,
    endDate: null,
    notes: ''
  },
  drawerState: EPanelDrawerState.HalfOpen,
  selectedSegmentId: null,
  selectedSegmentRef: null,
  decodedGeometry: null,
  segmentInfo: null,
  isSegmentSelected: false,
  editingOverrideId: null,
  originalFormValues: null,
  hoveredUpdateId: null,
  selectedUpdateId: null,
  lastSavedOverrideId: null,
  selectedSegments: {},
  segmentGroups: [],
  segmentError: false,
  isSaving: false
};
